"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getChild(parent, path) {
    var _a;
    var childObj = parent;
    for (var i = 0; i < path.length; i += 1) {
        var field = path[i];
        if (typeof childObj !== 'object') {
            throw new Error("Could not get child ".concat(field, " of ").concat(childObj));
        }
        if (Array.isArray(childObj)) {
            childObj = childObj[+field];
        }
        else {
            childObj = (_a = childObj === null || childObj === void 0 ? void 0 : childObj[field]) !== null && _a !== void 0 ? _a : null;
        }
    }
    return childObj;
}
exports.default = getChild;
